export default __webpack_public_path__ + "static/media/README.6f834464.md";